import { render } from "./DashboardCharts.vue?vue&type=template&id=74397845&scoped=true"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"

import "./DashboardCharts.vue?vue&type=style&index=0&id=74397845&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74397845"]])

export default __exports__